module.exports = __webpack_public_path__ + "static/media/pencil-paintbrush.0a5f7ee9.svg";